module.exports = __webpack_public_path__ + "static/hexagoncasestudy-3e4ad0de17d62de2807ac4d5cb651022.png";